import { IAppConfig, IAppConfigId } from '@/features/shared/IAppConfig';
import { container } from 'inversify-props';
import { useRoute, useRouter } from 'vue-router';

export default function useNavigate() {
    const appConfig = container.get<IAppConfig>(IAppConfigId);
    const route = useRoute();
    const router = useRouter();

    type Dictionary<T> = { [key: string]: T };
    interface Location {
        name?: string;
        query?: Dictionary<string | (string | null)[] | null | undefined>;
        params?: Dictionary<string>;
    }

    function navigate(location: Location) {
        // merge query items
        const query = {
            ...route.query,
            ...location.query,
            token: appConfig.token
        };

        // remove empty items
        for (const q in query) {
            if (Object.prototype.hasOwnProperty.call(query, q)) {
                if (query[q] === null || query[q] === undefined) {
                    delete query[q];
                }
            }
        }

        return router.push({ ...location, ...query });
    }

    return { navigate };
}
